import { ResetPasswordInput } from '../../graphql/API';
import { serviceResetPassword } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueResetPassword = async (input: ResetPasswordInput): Promise<boolean> => {
  const result = await executeGql(
    serviceResetPassword,
    {
      input,
    },
    'iam',
  );
  return processGqlResult('data.serviceResetPassword', result);
};
